module.exports = __webpack_public_path__ + "static/media/pengetahuan.5a4cdcdc.svg";